import withMessageContainer from './hocs/with-message-container';
import { ContentInfo } from './styles';
import useCountDown from '../../hooks/use-countdown';

const ConfirmModal = ({ onCountdownDone }) => {
  const [timeLeft] = useCountDown(onCountdownDone);

  return (
    <ContentInfo>
      You will be logged out in
      {' '}
      {timeLeft / 1000}
      , to stop this process move mouse or press any key.
    </ContentInfo>
  );
};
export default withMessageContainer(ConfirmModal);
